
export default function BusinessSection() {
  const businesses = [
    {
      number: '01',
      icon: 'ri-scan-line',
      title: 'ボディスキャン＆\n健康アドバイス',
      description: '人とペットを対象に、最新のボディスキャン技術で健康状態を可視化。一人ひとりのライフスタイルに合わせた、きめ細やかな健康アドバイスを提供します。',
    },
    {
      number: '02',
      icon: 'ri-user-star-line',
      title: 'ウェルビーイング\n支援者育成',
      description: '健康アドバイザーやウェルビーイング支援者の育成・認定プログラムを展開。専門知識とホスピタリティを兼ね備えた人材を社会に送り出します。',
    },
    {
      number: '03',
      icon: 'ri-shopping-bag-line',
      title: '健康・福祉関連\n商品サービス',
      description: '健康・福祉・生活の質向上に役立つ商品やサービスの企画・製造・販売。信頼できる品質で、日々の暮らしをサポートします。',
    },
    {
      number: '04',
      icon: 'ri-heart-3-line',
      title: 'こころとからだの\n相談・研究',
      description: '心身の健康や幸福感に関する相談窓口の運営、調査研究、実践的なプログラムの開発と提供を行います。',
    },
    {
      number: '05',
      icon: 'ri-building-2-line',
      title: '企業・地域向け\nプログラム',
      description: '健康経営やウェルビーイング向上を目指す企業・自治体向けに、講座・研修・イベントを企画・実施します。',
    },
    {
      number: '06',
      icon: 'ri-book-open-line',
      title: '教育・啓発・\nコンテンツ制作',
      description: '講演会、セミナー、ワークショップの開催をはじめ、書籍・教材・オンラインコンテンツの制作・発信を通じて、ウェルビーイングの輪を広げます。',
    },
    {
      number: '07',
      icon: 'ri-team-line',
      title: '社会貢献・\n共助の仕組みづくり',
      description: '地域の交流促進、ボランティア活動支援、共助ネットワークの構築など、人と人がつながる場づくりを推進します。',
    },
    {
      number: '08',
      icon: 'ri-bear-smile-line',
      title: '人とペットの\nウェルビーイング',
      description: '人とペットのより良い関係構築、動物福祉の向上、アニマルセラピーなど、共生社会の実現に向けた取り組みを展開します。',
    },
  ];

  return (
    <section id="business" className="py-32 bg-[#F7F9FB]">
      <div className="max-w-[1200px] mx-auto px-10">
        {/* セクションタイトル */}
        <div className="text-center mb-16">
          <p className="text-xs font-semibold tracking-widest bg-gradient-to-r from-[#4A90E2] to-[#50C9C3] bg-clip-text text-transparent mb-4">
            OUR BUSINESS
          </p>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A2B3C]">
            事業内容
          </h2>
        </div>

        {/* 事業カード */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {businesses.map((business, index) => (
            <article
              key={index}
              className="bg-white rounded-[24px] p-12 shadow-md hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 relative"
            >
              {/* 番号ラベル */}
              <div className="absolute top-8 left-8 w-10 h-10 rounded-full bg-gradient-to-br from-[#4A90E2] to-[#50C9C3] flex items-center justify-center">
                <span className="text-white text-lg font-bold">{business.number}</span>
              </div>

              {/* アイコン */}
              <div className="absolute bottom-8 right-8 w-12 h-12 rounded-full bg-gradient-to-br from-[#E8F4F8] to-[#F0F9FF] flex items-center justify-center">
                <i className={`${business.icon} text-xl text-[#4A90E2]`}></i>
              </div>

              {/* タイトル */}
              <h3 className="text-xl font-bold text-[#1A2B3C] mb-5 mt-12 leading-snug whitespace-pre-line">
                {business.title}
              </h3>

              {/* 説明 */}
              <p className="text-[15px] leading-relaxed text-[#5A6C7D] pr-12">
                {business.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
